import { AppBar, Toolbar, Typography } from "@mui/material";
import logo from "../../../assets/litcolaw.png";

function TopNavBar() {
  return (
    <div>
      <AppBar position='fixed' style={{ backgroundColor: "black" }}>
        <Toolbar>
          <Typography style={{ marginRight: "auto", height: "40px" }}>
            <a href='https://www.litwiniuk.com/' target="_blank" rel="noreferrer">
              <img src={logo} className='App-logo' alt='logo' style={{ width: "auto", maxHeight: "36px" }} />
            </a>
          </Typography>
          <Typography sx={{ fontSize: 28, color: "white", display: { xs: "none", sm: "block" } }}>
            LitCafe&#769;
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}
export default TopNavBar;
